"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JitaSettings = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var JitaSettings = (0, _keyMirror.default)({
  ENABLED: null,
  DISABLED: null
});
exports.JitaSettings = JitaSettings;